import { trpc } from '../system/trpc'
import { format } from 'date-fns'

export const getPreviousWeekTime = async (staffId, beforeDate = new Date()) => {
    const r = await trpc.timeTracking.getWeeklyPreviousTime.query({
        staffId,
        beforeDate: format(beforeDate, 'yyyy-MM-dd'),
    })
    return r?.timeEntries || []
}
export const getPreviousDayTime = async (staffId, beforeDate = new Date()) => {
    const r = await trpc.timeTracking.getDailyPreviousTime.query({
        staffId,
        beforeDate: format(beforeDate, 'yyyy-MM-dd'),
    })
    return r?.timeEntries || []
}
